export const toErrorWithMessage = (maybeError: unknown) => {
    try {
        return new Error(JSON.stringify(maybeError));
    } catch {
        return new Error(String(maybeError));
    }
};

export const buildPaginationQueryString = (
    pageNumber?: string | number,
    pageSize?: string | number,
    separator = '?',
) => {
    const params: string[] = [];

    if (pageSize !== undefined && '' !== `${pageSize}`) {
        params.push(`pageSize=${pageSize}`);
    }

    if (pageNumber !== undefined && '' !== `${pageNumber}`) {
        params.push(`pageNumber=${pageNumber}`);
    }

    return params.length ? `${separator}${params.join('&')}` : '';
};
